import { render, staticRenderFns } from "./altaCategoriaPromocion.vue?vue&type=template&id=41803cbd&scoped=true"
import script from "./altaCategoriaPromocion.vue?vue&type=script&lang=js"
export * from "./altaCategoriaPromocion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41803cbd",
  null
  
)

export default component.exports